import { CommonModule } from '@angular/common';
import { Component } from '@angular/core';
import { MzicSvgComponent } from '@mzic/mzic-components';

interface WriterPublisherItem {
  id: string;
  name: string;
  type?: string;
  rightsType?: string;
  percentage?: number;
  size?: string;
  icon?: string;
  hasSpotifyId?: boolean;
  hasAppleId?: boolean;
  isFile?: boolean;
}

interface ErrorMessage {
  type: 'warning' | 'error' | 'soft-error';
  message: string;
}

@Component({
  selector: 'mzic-writer-publisher-rows',
  imports: [CommonModule, MzicSvgComponent],
  templateUrl: './writer-publisher-rows.component.html',
  styleUrls: ['./writer-publisher-rows.component.scss'],
})
export class WriterPublisherRowsComponent {
  // Exemplos de compositores e editoras
  writersPublishers: WriterPublisherItem[] = [
    {
      id: '1',
      name: 'João Silva',
      type: 'Compositor',
      rightsType: 'Mechanical Rights',
      percentage: 50,
      hasSpotifyId: true,
      hasAppleId: false,
    },
    {
      id: '2',
      name: 'Maria Santos',
      type: 'Editora',
      rightsType: 'Publishing Rights',
      percentage: 30,
      hasSpotifyId: false,
      hasAppleId: true,
    },
    {
      id: '3',
      name: 'Pedro Costa',
      type: 'Compositor',
      rightsType: 'Sync Rights',
      percentage: 20,
      hasSpotifyId: true,
      hasAppleId: true,
    },
  ];

  // Exemplos de arquivos/partituras
  files: WriterPublisherItem[] = [
    {
      id: '4',
      name: 'partitura-completa.pdf',
      size: '1.2 MB',
      icon: 'mzic-download.svg',
      isFile: true,
    },
    {
      id: '5',
      name: 'letra-da-musica.docx',
      size: '245 KB',
      icon: 'mzic-document.svg',
      isFile: true,
    },
    {
      id: '6',
      name: 'notas-musicais.pdf',
      size: '890 KB',
      icon: 'mzic-music-note.svg',
      isFile: true,
    },
  ];

  // Mensagens de erro e aviso
  errorMessages: ErrorMessage[] = [
    {
      type: 'warning',
      message: 'Você precisa completar 25.50% dos direitos autorais para prosseguir.',
    },
    {
      type: 'error',
      message: 'Os percentuais excedem 100%. Por favor, ajuste os valores.',
    },
    {
      type: 'soft-error',
      message: 'Este campo é obrigatório.',
    },
    {
      type: 'soft-error',
      message: 'O arquivo selecionado não é válido.',
    },
  ];

  // Ícones disponíveis para demonstração
  availableIcons = [
    'mzic-download.svg',
    'mzic-document.svg',
    'mzic-music-note.svg',
    'mzic-playlist-2.svg',
    'mzic-microphone.svg',
    'mzic-edit.svg',
    'mzic-upload.svg',
    'mzic-star.svg',
  ];

  // Simula a remoção de um item
  removeItem(item: WriterPublisherItem): void {
    console.log('Removing item:', item.name);
  }

  // Simula o download de um arquivo
  downloadFile(item: WriterPublisherItem): void {
    console.log('Downloading file:', item.name);
  }

  // Trunca nomes de arquivo muito longos
  truncateFileName(fileName: string, maxLength: number = 30): string {
    if (fileName.length <= maxLength) return fileName;
    const extension = fileName.substring(fileName.lastIndexOf('.'));
    const name = fileName.substring(0, fileName.lastIndexOf('.'));
    const truncatedName = name.substring(0, maxLength - extension.length - 3);
    return `${truncatedName}...${extension}`;
  }
}